<template>
  <TnSupportText v-if="errorMessage" status="critical" :text="errorMessage" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { TnSupportText } from '@telenornorgeinternal/telegrafen-vue3-core';

interface ElvisError {
  type?: string;
  subtype?: string;
  message?: string;
}

// Callers surface rejected API payloads, which are `unknown` at the call site.
const props = defineProps<{ error?: unknown }>();

const { t } = useI18n();

const errorMessage = computed(() => {
  const error = props.error as ElvisError | null | undefined;
  if (!error) return null;
  if (!error.type) return error.message ?? null;

  const key = error.subtype ? `${error.type}.${error.subtype}` : error.type;
  const translated = t(key);

  return translated !== key ? translated : (error.message ?? null);
});
</script>
